import React, { useState } from 'react'

export default function NftAssetCard({ nft = {}, selected, loading, onSelect, t = (key) => key }) {
    const [imageFailed, setImageFailed] = useState(false)
    const id = String(nft.id)
    const name = nft.name || `NFT #${id}`
    const showImage = Boolean(nft.image) && !imageFailed
    const className = `nft-asset-card ${selected ? 'is-selected' : ''} ${loading || nft.metadataStatus === 'loading' ? 'is-loading' : ''}`.trim()
    const content = <>
        <div className="nft-asset-card__media">
            {showImage
                ? <img src={nft.image} alt={name} loading="lazy" onError={() => setImageFailed(true)} />
                : <span className="nft-asset-card__placeholder" aria-label={t('NFT 图片暂不可用')}><i className="fa fa-image" /></span>}
            {selected && <span className="nft-asset-card__selected-mark" aria-hidden="true"><i className="fa fa-check" /></span>}
        </div>
        <div className="nft-asset-card__meta">
            <strong>{name}</strong>
            <span title={id}>#{id}</span>
        </div>
    </>

    if (onSelect) {
        return <button
            type="button"
            className={className}
            onClick={() => onSelect(id)}
            disabled={loading}
            aria-label={`${selected ? t('已选择') : t('选择')} NFT #${id}`}
            aria-pressed={Boolean(selected)}
        >
            {content}
        </button>
    }

    return <article className={className}>{content}</article>
}
